/** AUTO GENERATED FROM "node ./src/utils/build-icons.js". DO NOT TOUCH. * */
import React from 'react';
import classNames from 'classnames';

class Icon extends React.PureComponent {
  render() {
    const { className, svgRef, ...otherProps } = this.props;
    return (
      <svg
        width="55.84"
        height="64.32"
        viewBox="0 0 55.84 64.32"
        fill="currentColor"
        className={classNames('nmx-icon', className)}
        ref={svgRef}
        {...otherProps}>
        <path
          fill="#ffb81c"
          d="M54.62 0a1.27 1.27 0 0 1 1.22 1.29 1.25 1.25 0 0 1-1.1 1.2H1.22A1.25 1.25 0 0 1 1.09 0Z"
          className="icon-fill icon-accent"/>
        <path
          fill="#fff"
          d="M28.2 10.38a1.26 1.26 0 0 1 1.27 1.12V63a1.252 1.252 0 1 1-2.5.13V11.68a1.24 1.24 0 0 1 1.23-1.25Z"
          className="icon-fill icon-base"/>
        <path
          fill="#fff"
          d="M27.63 10.33a1.28 1.28 0 0 1 1.6-.09l.11.09 23.88 22.26a1.26 1.26 0 0 1 .12 1.77 1.25 1.25 0 0 1-1.72.15l-.1-.09-23-21.42L5.41 34.42a1.22 1.22 0 0 1-1.67 0l-.1-.09a1.24 1.24 0 0 1 0-1.67l.09-.1Z"
          className="icon-fill icon-base"/>
      </svg>

    );
  }
}

Icon.displayName = 'OneArrowPointingUpToHorizontalLineIcon';

export default Icon;
